import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import classNames from 'classnames';
import {
  WithStyles,
  createStyles,
  Typography,
  Button,
  Modal,
  Card,
  CardContent,
  CardActions,
  CardHeader,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Paper,
  Link,
  TableHead,
  Table,
  TableBody,
  TextField,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";

import {
  MyPATCollapse,
  MyPATLink,
  dateService,
  MyPATDialog,
} from "../../common";
import { BorderAll } from "@material-ui/icons";
import PerfectScrollbar from "react-perfect-scrollbar";
import SelectContentOwners from "../components/SelectContentOwners";
import { string } from "prop-types";
import { ContentRequest, Subject } from "../types/ContentRequest";
import MyPATUploadPreview, { convertFileOrUrlToPreviewItem, PreviewItem } from "../../common/MyPATUploadPreview";

const styles = (theme: Theme) =>
  createStyles({
    customCard: {
      background: "#FFF",
      boxShadow: "0px 0px 10px rgb(0 0 0 / 10%)",
      borderRadius: 8,
      marginBottom: 24,
      padding: 24,
    },
    testName: {
      fontSize: 20,
      color: "#666",
      fontWeight: 400,
      marginBottom: 20,
    },
    marginTop: {
      marginTop: '20px'
    },
    NotesLabel:{
      fontWeight: 700,
    },
    subjectName: {
      fontSize: 16,
      color: "#666",
      fontWeight: 400,
      "& span": {
        fontWeight: 700,
      },
    },
    orderNotes: {
      fontSize: 16,
      color: "#1d7dea",
      backgroundColor: "rgba(29, 125, 234, 0.08)",
      fontWeight: 600,
      borderRadius: 4,
      padding: "2px",
      height: 28,
      width: 129,
      textAlign: "center",
    },
    orderBy: {
      fontSize: 14,
      color: "#999",
      fontWeight: 600,
      "& span": {
        color: "#515C65",
      },
    },
    headingText: {
      fontSize: 20,
      fontWeight: 700,
      color: "#666",
      marginBottom: 18,
      marginTop: 16,
    },
    normalText: {
      fontSize: 14,
      fontWeight: 400,
      color: "#666",
    },
    maxHeight4: {
      maxHeight: 400,
    },
    imgAlign:{
      marginLeft: 30,
      '&> img':{
        verticalAlign: '-6px'
      }
    },
  });

//@ts-ignore
interface OrderNotesProps extends WithStyles<typeof styles> {
  classes: any;
  testName: string;
  subjects: Subject[];
  type: string;
  orderNoteBy: string;
  note: string;
  transferToParent: Function;
  contentsubType: any;
  requestData:ContentRequest,
  requestContentType:string,
  showGoal:boolean;
  attachments?: string[];
}

interface OrderNotesStates {
  attachmentPreviewList: PreviewItem[];
}
class OrderNotes extends Component<OrderNotesProps, OrderNotesStates> {
  constructor(props: OrderNotesProps) {
    super(props);
    this.state = {
      attachmentPreviewList: []
    }
  }
  handleAttachPreviewListCreation = (attachments: string[]) => {
    this.setState({
      attachmentPreviewList: attachments.map(attachment => convertFileOrUrlToPreviewItem(attachment))
    })
  }
  componentDidMount() {
    if(this.props.attachments) {
      this.handleAttachPreviewListCreation(this.props.attachments)
    }
  }
  componentDidUpdate(prevProps: OrderNotesProps) {
    if(prevProps.attachments !== this.props.attachments && this.props.attachments) {
      this.handleAttachPreviewListCreation(this.props.attachments)
    }
  }
  
getNamesofRequest=()=>{
  const{requestData,classes, subjects: relevantSubjects}=this.props;
     const subjects=relevantSubjects || _.get(requestData,"requestInfo.details.subjects",[]);
     const type=_.get(requestData,"requestInfo.type",'');
      if(type==="question"){
        const names:any=new Set();
          subjects.forEach((subject:any)=>{
             const questions=_.get(subject,"questions",[]);
               questions.forEach((question:any)=>{
                 names.add(question.type);
               })
          })
          const namesText=[... names].join(', ');
          return <span className={classes.testName}>
                   <span>{`${_.capitalize(type)} Type: `}</span>
                   <span className={classes.NotesLabel}>{namesText}</span>
              </span>
      }else{
         const name=_.get(requestData,"requestInfo.details.testDetails.name",'');
         return <span className={classes.testName}>
                  <span>{`${_.capitalize(type)} Name: `}</span>
                  <span className={classes.NotesLabel}>{name}</span>
               </span>
      }
}
  getGoal=()=>{
    return _.get(this.props.requestData, 'requestInfo.details.courseTypes[0].name', 'N/A');
  }
  getSubjectsName=()=>{
    const names:string []=[];
    const{requestData, subjects}=this.props;

    if(_.isEmpty(requestData))
     return "N/A";
    
    if(subjects) {
      subjects.forEach(subject => names.push(_.capitalize(subject.name)))
    } else {
      const allSubjects =_.get(requestData,"requestInfo.details.subjects",[]);
      allSubjects.forEach((subject:any)=>{
        names.push(_.capitalize(subject.name));
      });
    }
    return names.length>0? names.join(', '):"N/A"
  }
  getType=()=>{
    const{requestData}=this.props;
    if(_.isEmpty(requestData))
       return "N/A";
      return _.get(requestData,"requestInfo.details.testDetails.type","N/A")
  }
  render() {
    const { classes, testName, subjects, type,
             orderNoteBy, note,requestContentType,requestData,showGoal } = this.props;
    const { attachmentPreviewList } = this.state;
    return (
      <>
        <Grid className={classes.customCard}>
          <Grid container justify="space-between" alignItems="center">
            <Grid item>
              <Typography className={classes.testName}>
                {this.getNamesofRequest()}
              </Typography>
            </Grid>
            {requestContentType==='question'&&
            <>
            <Grid item>
              <Typography className={classes.subjectName}>
                Subjects: <span>{this.getSubjectsName()}</span>
              </Typography>
            </Grid>
            </>}
          </Grid>
          {requestContentType!=='question'&&
            // /assets/svg/contentRequest/goal.svg
            <>
          <Grid container justify="space-between" alignItems="center">
            <Grid item>
              <Typography className={classes.subjectName}>
                Subjects: <span>{this.getSubjectsName()}</span>
              </Typography>
            </Grid>
            
            <Grid item>
              <Grid container justify="space-between">
                <Grid item>
                  <Typography className={classes.subjectName}>
                    Type: <span>{this.getType()}</span>
                  </Typography>
                </Grid>
                {showGoal&&<Grid item>
                  <Typography className={[classes.subjectName, classes.imgAlign].join(' ')}>
                    <img src="../../../assets/svg/contentRequest/goal.svg" alt ="goalImg"/> Goal: <span>{this.getGoal()}</span>
                  </Typography>
                </Grid>}
              </Grid>
            </Grid>
            
          </Grid>
          </>
            }
        </Grid>
        
        <Grid className={classes.customCard}>
          <Grid container justify="space-between" alignItems="center">
            <Grid item>
              <Typography className={classes.orderNotes}>
                ORDER NOTES
              </Typography>
            </Grid>
            <Grid item>
              <Typography className={classes.subjectName}>
                By: <span>{orderNoteBy || 'N/A'}</span>
              </Typography>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item className={classNames(classes.maxHeight4, classes.marginTop)}>
              <PerfectScrollbar>
                <Typography className={(classes.normalText)}>
                  <div dangerouslySetInnerHTML={{ __html: note }} />
                </Typography>
              </PerfectScrollbar>
            </Grid>
            <Grid container className={classes.marginTop}>
              <MyPATUploadPreview list={attachmentPreviewList} itemsDownloadable />
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  }
}

// @ts-ignore
export default withStyles(styles)(OrderNotes);
